import { optionTitle_externalImages } from './ExternalImagesOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const ExternalImagesOption: LazyOption = createLazyOption(
    {
        key: 'externalImagesOption',
        titleStringKey: optionTitle_externalImages,
        searchTermsStringKey: optionTitle_externalImages,
        isHidden: () => false,
    },
    lazyFullModule,
    m => m.default
);
export default ExternalImagesOption;
